import { useSelector } from 'react-redux';
import NetAvailableMargin from './NetAvailableMargin';

export default function SubHeader() {
  const userData = useSelector((state) => state.user.user);

  return (
    <div className="tw-w-full tw-h-14 tw-px-[2.5%] tw-flex tw-justify-between tw-items-center tw-bg-[#051F23]">
      <div className="tw-text-[25px] tw-font-cathit tw-text-[#FFFFFF] tw-capitalize max-sm:tw-text-[18px]">
        Welcome {userData?.firstName?.toLowerCase()}!
      </div>

      {userData?.isDematUser && <NetAvailableMargin />}
    </div>
  );
}
